import { render, staticRenderFns } from "./CDFProductData.vue?vue&type=template&id=491d860d"
import script from "./CDFProductData.vue?vue&type=script&lang=js"
export * from "./CDFProductData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports